const legal = {
  legal: {
    privacy: {
      title: "Privacy Policy",
      lastUpdatedLabel: "Last updated",
      intro:
        "This policy explains how personal data is collected and processed when you use this website (professional portfolio, blog, contact form and newsletter subscription).",
      controller: {
        title: "Data controller",
        items: [
          "Controller: Alexandre SANOU (professional portfolio)",
          "Contact: via the website contact form or LinkedIn",
          "Area: Ile-De-France / Remote",
        ],
      },
      processing: {
        title: "Data we process",
        sections: [
          {
            title: "Contact form",
            items: ["Name", "Email", "Phone number", "Subject", "Message", "Technical metadata (submission date)"],
          },
          {
            title: "Newsletter (blog)",
            items: ["Name", "Email", "Technical metadata (subscription date)"],
          },
          {
            title: "Technical data",
            items: [
              "Preferences stored locally (language)",
              "Admin session data stored locally by the auth client",
              "Logs and analytics (if enabled): page views, events, technical info (browser, device)",
            ],
          },
        ],
      },
      purposes: {
        title: "Purposes and legal bases",
        items: [
          "Respond to your requests (contact): legitimate interest and/or pre-contractual steps.",
          "Send a newsletter (if you subscribe): consent (withdraw anytime).",
          "Improve the site and measure audience (if enabled): consent when required by law.",
          "Secure the site and prevent abuse: legitimate interest.",
        ],
      },
      recipients: {
        title: "Recipients and processors",
        intro: "Data may be processed by providers strictly necessary to operate the site:",
        items: [
          "Supabase (database, authentication, storage): hosting and processing for contact/admin data.",
          "EmailJS (email delivery): contact data is transmitted to deliver your message.",
          "Calendly (booking links): data you provide directly to Calendly is processed by them.",
          "Hosting/CDN provider (depending on deployment): technical logs and content delivery.",
          "Google Analytics 4 / analytics tools (if enabled): navigation statistics.",
        ],
      },
      retention: {
        title: "Retention periods",
        items: [
          "Contact messages: up to 24 months after the last exchange, then deletion/archiving.",
          "Newsletter: until unsubscribe, then up to 3 years after the last active contact.",
          "Technical logs: limited duration, typically up to 12 months (depending on hosting).",
        ],
      },
      transfers: {
        title: "International transfers",
        text:
          "Some providers may process data outside the EU/EEA. Where applicable, appropriate safeguards are used when available (e.g., SCCs and technical measures).",
      },
      security: {
        title: "Security",
        text:
          "Reasonable technical and organizational measures are implemented to protect your data. No system is infallible, so absolute security cannot be guaranteed.",
      },
      rights: {
        title: "Your rights (GDPR)",
        intro: "You have the following rights, subject to GDPR conditions:",
        items: ["Access, rectification, erasure", "Restriction and objection", "Portability", "Withdraw consent anytime", "Lodge a complaint with a supervisory authority"],
        contact: "To exercise your rights, use the contact form and specify your request.",
      },
      aiAct: {
        title: "Transparency (EU AI Act)",
        text:
          "This website does not provide an interactive AI system intended to produce decisions about you. Data submitted via the form/subscription is not used to train AI models. If assistance tools (including AI) are used to draft content or replies, this is done under human oversight and without automated decision-making about you.",
      },
      changes: {
        title: "Changes",
        text: "This policy may change. The date at the top of the page indicates the latest version.",
      },
      disclaimer: "Info: this document is provided for information only and is not legal advice.",
    },
    terms: {
      title: "Terms of Service",
      lastUpdatedLabel: "Last updated",
      intro:
        "These terms govern your use of this website (portfolio, blog, forms and content). By browsing the site, you agree to these terms.",
      scope: {
        title: "Purpose",
        items: [
          "Provide professional information (portfolio, services, case studies).",
          "Publish content (blog) and enable newsletter subscription.",
          "Enable contact via form and external links (e.g., Calendly).",
        ],
      },
      access: {
        title: "Access",
        text:
          "The site is provided as-is and may be interrupted (maintenance, incident, technical constraints). Continuous availability is not guaranteed.",
      },
      conduct: {
        title: "Acceptable use",
        items: [
          "Do not attempt unauthorized access to admin, code or data.",
          "Do not disrupt the site (abusive scraping, attacks, spam).",
          "Do not use forms to send unlawful content.",
        ],
      },
      ip: {
        title: "Intellectual property",
        text:
          "Unless stated otherwise, content (text, visuals, branding) is protected. Any reproduction/use beyond personal viewing requires authorization.",
      },
      userContent: {
        title: "Messages and submissions",
        text:
          "Information you submit via forms (or any indicated channel) must be accurate and not infringe third-party rights. You remain responsible for your messages.",
      },
      newsletter: {
        title: "Newsletter",
        items: [
          "Subscription is voluntary and based on consent.",
          "You can unsubscribe at any time via an unsubscribe link (if present) or by contacting via the contact form.",
        ],
      },
      external: {
        title: "External links",
        text:
          "The site may link to third-party services (LinkedIn, GitHub, Calendly). Their content and policies are their responsibility.",
      },
      liability: {
        title: "Liability",
        text:
          "Site information is provided for informational purposes. Despite care, errors may occur. Liability is excluded for indirect damages related to the use of the site.",
      },
      law: {
        title: "Governing law",
        text:
          "These terms are governed by French law. In case of dispute, the parties will seek an amicable solution before any action.",
      },
      changes: {
        title: "Changes to these terms",
        text: "These terms may be updated. The date at the top of the page indicates the latest version.",
      },
      disclaimer: "Info: this document is provided for information only and is not legal advice.",
    },
  },
};

export default legal;
